import { Navigate } from "react-router-dom";

export default function SymbolConfigDetailPage() {
  return <Navigate to="/forex/config/detail?pkg=symbol_config" replace />;
}
